import Box from "@/common/components/Box";
import Button from "@/common/components/Button";
import TextField from "@/common/components/TextField";
import { Link, useParams } from "react-router-dom";
import useClientPermission from "../../hooks/useClientPermission";
import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import TextArea from "@/common/components/TextArea";
import { ShowHeader } from "@/common/components/ShowHeader";

const ClientPermissionsShow = () => {
  const { id } = useParams();

  const {
    data: initialPermission,
    isPending: initialPermissionIsPending,
    error: initialPermissionError = {} as any,
    refetch: refetchPermission,
  } = useClientPermission(id || '');

  const disableUpdateButton = initialPermissionIsPending || initialPermissionError?.status === 403;

  return (
    <div>
      <ShowHeader
        goBack
        goBackProps={{ 
          fallback: '/client-permissions', 
          searchLastRouteFromFallback: true
        }}
        titleClassName="font-normal text-lg text-white-400"
        subtitleClassName="font-normal text-lg"
        title='Permissões - Clientes'
        subtitle={initialPermission?.display_name}
        buttons={(
          <Link
            to={disableUpdateButton ? '' : `/client-permissions/${id}/edit`}
            className={disableUpdateButton ? "cursor-default" : ''}
          >
            <Button
              operationKlassToCheckPermission="Admin::Client::Permissions::Update"
              data-testid='update_permission_button'
              type="submit"
              className="shadow-[4px_4px_8px_4px_rgba(0,_0,_0,_0.2)]"
              disabled={disableUpdateButton}
            >
              Editar
            </Button>
          </Link>
        )}
      />

      {initialPermissionIsPending ? (
        <Box>Carregando...</Box>
      ) : (
        <ErrorMessageWrapper
          className="max-h-[calc(100vh-128px)]"
          statusCode={initialPermissionError?.status}
          refetchFunction={refetchPermission}
        >
          <Box className="flex flex-col gap-4 shadow-[4px_4px_8px_4px_rgba(0,_0,_0,_0.2)]">
            <p className="text-lg font-bold">
              {initialPermission?.display_name}
            </p>

            <div className="flex gap-2">
              <TextField
                label="Nome"
                value={initialPermission?.display_name}
                data-testid="display_name_input"
                className="w-1/2"
                disabled
              />
              <TextField
                label="Classe de operação"
                value={initialPermission?.operation_klass}
                data-testid="operation_klass_input"
                className="w-1/2"
                disabled
              />
            </div>

            <TextField
              label="Descrição"
              value={initialPermission?.description}
              data-testid="description_input"
              disabled
            />

            <TextArea
              label="Propiedades"
              placeholder="{}"
              value={JSON.stringify(initialPermission?.properties, null, 4)}
              rows={8}
              disabled
            />
          </Box>
        </ErrorMessageWrapper>
      )}

    </div>
  );
};

export default ClientPermissionsShow;
